module.exports = __webpack_public_path__ + "img/yongcheng.196f785b.png";